<template>
  <pt-link-form ref="form" class="pt-link-form__withData"></pt-link-form>
</template>

<script>
import PtLinkForm from './form'
export default {
  name: 'pt-link-form__withData',
  components: {
    'pt-link-form': PtLinkForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  methods: {
    submit () {
      this.form.validate().then(formValue => {
        this.$emit('getSubmitLoading')
        this.$store.dispatch('creatLink', formValue).then(data => {
          // doing something ...
          this.$message.success('创建链接成功')
          this.$emit('submitSuccess')
          history.go(-1)
        }).catch(errorMessage => {
          this.$emit('submitSuccess')
          this.$message.error(errorMessage || '创建链接失败')
        })
      })
    }
  }
}
</script>
